import React, {useState} from "react";

import {DivCarousel} from "./styles";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Pagination, Thumbs} from "swiper";
import {Cidade, ContainerCarousel, Img} from "./styles";
import ImgTemporaria from "../../assets/img/Rectangle 41.svg";

export const CarouselHotels = ({images}) => {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [brokenImageUrls, setBrokenImageUrls] = useState([]);

    const handleImageError = (url) => {
        if (!brokenImageUrls.includes(url)) {
            setBrokenImageUrls(prev => [...prev, url]);
        }
    };

    const validImages = images.filter(image => !brokenImageUrls.includes(image.url));

    if (!images || images.length === 0) {
        return null;
    }

    return(
        <DivCarousel>
            <Swiper
                style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",
                    "height": 300
                }}
                loop={validImages.length > 1}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
            >
                {validImages.map((item,index) =>
                    <SwiperSlide key={item.url || index}>
                        <img src={item.url} onError={() => handleImageError(item.url)} alt={`Slide ${index + 1}`} />
                    </SwiperSlide>
                )}

            </Swiper>
            <Swiper
                onSwiper={setThumbsSwiper}
                loop={true}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
            >
                {validImages.map((item,index) =>
                    <SwiperSlide key={item.url || index} style={{height: "60px"}}>
                        <img src={item.url} onError={() => handleImageError(item.url)} alt={`Thumbnail ${index + 1}`} />
                    </SwiperSlide>
                )}

            </Swiper>
        </DivCarousel>
    )
}

export const CarouselDefault = ({slidesPerView, images}) => {
    return (
        <ContainerCarousel>
            <Swiper
                slidesPerView={slidesPerView}
                breakpoints={{
                    568: { slidesPerView: 4 },
                }}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
            >
                {images.map((item, index) => {
                    const { id, label } = item;
                    return (
                        <SwiperSlide key={index}>
                            <Img src={ImgTemporaria} alt={label} />
                            <Cidade>Rio De Janeiro</Cidade>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </ContainerCarousel>
    )
}
